import type { RouteRecordRaw } from "vue-router"

const factRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "factList",
    component: () => import("@/templates/facts/FactList.vue")
  }
]

export default factRoutes
